import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/RobotSpecsSection.css';

const RobotSpecsSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="robot-specs-section" id="technology">
      <div className="robot-specs-container">
        <h2 className="robot-specs-title">Technology</h2>
        
        <div className="robot-anatomy-part">
          <div className="robot-anatomy-image">
            <img src="/images/page16-p.png" alt="BOBO Robot Anatomy" className="anatomy-main-image" />
          </div>
        </div>
        
        <div className="robot-specs-part">
          <div className="specs-grid">
            {/* Materials Row */}
            <div className="specs-row">
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.materials')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.mainBody')}<br />
                    {t('technology.tail')}
                  </p>
                </div>
              </div>
            </div>
            
            {/* Size & Weight Row */}
            <div className="specs-row">
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.size')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.mainBodyDiameter')}<br />
                    {t('technology.tailLength')}
                  </p>
                </div>
              </div>
              
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.weight')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.weightValue')}
                  </p>
                </div>
              </div>
            </div>
            
            {/* Motion & Battery Row */}
            <div className="specs-row">
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.motion')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.totalDof')}<br />
                    {t('technology.tailControl')}
                  </p>
                </div>
              </div>
              
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.battery')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.batteryType')}<br />
                    {t('technology.batteryLife')}<br />
                    {t('technology.chargingTime')}
                  </p>
                </div>
              </div>
            </div>
            
            {/* Sensors & Drive System Row */}
            <div className="specs-row">
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.sensors')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.sensorType')}
                  </p>
                </div>
              </div>
              
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.driveSystem')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.propellerMotor')}
                  </p>
                </div>
              </div>
            </div>
            
            {/* Display & Connectivity Row */}
            <div className="specs-row">
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.display')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.displayType')}
                  </p>
                </div>
              </div>
              
              <div className="specs-col">
                <h3 className="specs-col-title">{t('technology.connectivity')}</h3>
                <div className="specs-content-container">
                  <p className="specs-col-content">
                    {t('technology.bluetooth')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RobotSpecsSection; 